module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/sofa/sofa.obj";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/sofa/sofa.obj
// module id = 632
// module chunks = 0